/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OperatorBookingsRequest
 */
export interface OperatorBookingsRequest {
    /**
     * The support operator's Gondola user id; returns the reservations they manually completed.
     * @type {string}
     * @memberof OperatorBookingsRequest
     */
    operatorUserId: string;
}

/**
 * Check if a given object implements the OperatorBookingsRequest interface.
 */
export function instanceOfOperatorBookingsRequest(value: object): value is OperatorBookingsRequest {
    if (!('operatorUserId' in value) || value['operatorUserId'] === undefined) return false;
    return true;
}

export function OperatorBookingsRequestFromJSON(json: any): OperatorBookingsRequest {
    return OperatorBookingsRequestFromJSONTyped(json, false);
}

export function OperatorBookingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperatorBookingsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'operatorUserId': json['operator_user_id'],
    };
}

export function OperatorBookingsRequestToJSON(json: any): OperatorBookingsRequest {
    return OperatorBookingsRequestToJSONTyped(json, false);
}

export function OperatorBookingsRequestToJSONTyped(value?: OperatorBookingsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operator_user_id': value['operatorUserId'],
    };
}

